@if (hasScopes) {
  <div class="table-cell-container">
    @if (!isEditing) {
      <div
        [ngClass]="{
            'isHighlighted': isHighlighted,
            'notHighlighted': !isHighlighted,
            'changed': isChanged && !newValueMatchesOriginalValue,
            'isDiv0': isDiv0
        }"
        (click)="startHighlightMode($event)"
        (dblclick)="startEditMode($event)"
        class="value-container"
        >
        @if (newValue !== '' && newValue !== null) {
          <span>{{formatItem(newValue, textFormat)}}</span>
        } @else {
          @if (equationValue !== 0 || displayNumForZero) {
            <span class="calculatedValue">{{formatItem(equationValue, textFormat)}}</span>
          }
          @if (equationValue === 0 && !displayNumForZero) {
            <span>-</span>
          }
        }
      </div>
    }
    @if (isEditing) {
      <input
        type="text"
        #editCellTextbox
        [(ngModel)]="newValue"
        (focusout)="editComplete()"
        (keyup.enter)="editComplete()"
        (click)="stopPropagation($event)"
        />
    }
  </div>
}
